import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

import { connect } from "react-redux";

class barchart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        {
          data: [15, 60, 20, 5, 10, 45, 36, 77, 25, 40],
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 380,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            // distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        xaxis: {
          categories: [],
          labels: {
            show: false,
          },
        },
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#000"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          offsetX: 0,
          //   dropShadow: {
          //     enabled: true,
          //   },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "Request By Department",
          align: "center",
          floating: true,
        },

        colors: ["#5664d2"],
        // colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
        //   '#f48024', '#69d2e7'
        // ],

        // subtitle: {
        //     text: 'Category Names as DataLabels inside bars',
        //     align: 'center',
        // },
        // tooltip: {
        //   theme: 'dark',
        //   x: {
        //     show: false
        //   },
        //   y: {
        //     title: {
        //       formatter: function () {
        //         return ''
        //       }
        //     }
        //   }
        // }
      },
    };
  }
  render() {
    return (
      <React.Fragment>
        {/* <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={380}
        /> */}
        {this.props.mrdeplistcount.length > 0 ? (
          <ReactApexChart
            options={{
              ...this.state.options,
              xaxis: {
                categories: this.props.mrdeplistcount.map(
                  (d) => d.userdepartment__name
                ),
                labels: {
                  show: false,
                },
              },
            }}
            series={[{ data: this.props.mrdeplistcount.map((d) => d.total) }]}
            type="bar"
          />
        ) : (
          <span>Loading... {this.props.mrdeplistcount.toString()}</span>
        )}
        {/* height="350" */}
        {/* <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height="350" /> */}
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { mrdeplistcount } = state.Dashboard;

  return {
    mrdeplistcount,
  };
};
export default connect(mapStatetoProps)(barchart);
